import * as React from "react";
import * as ReactDOM from "react-dom";

interface IProperties
{
    text: string,
    icon?: string,
    profile?: string,
    iconAlignRight?: boolean;
    iconTitle?: string;
    width: number;
}

export class TextWithIconColumn extends React.Component<IProperties>
{
    public static defaultProps: Partial<IProperties> = {
        width: 180
    };

    constructor(props: IProperties)
    {
        super(props);
    }

    render()
    {
        const { text, icon, profile, iconAlignRight, iconTitle, width } = this.props;

        return (
            <div
                className="n-table_cell"
                style={{
                    width: width
                }}>
                <div className="n-table_cell_text-w-icon" style={{
                    width: "100%"
                }}>
                    {!iconAlignRight && icon && <i className={`n-table_cell_icon mdi mdi-${icon}`}></i>}
                    {profile && <img src={profile} />}
                    <span className="n-table_cell_text" style={{
                        flex: 1
                    }}>{text}</span>
                    {iconAlignRight && icon && <i className={`n-table_cell_icon mdi mdi-${icon}`} title={iconTitle}></i>}
                </div>
            </div>
        );
    }
}